module.exports = __webpack_public_path__ + "static/wireframes-5-bcc386927bb1a1f1d9b97c5d2e7dc173.jpg";